import AnalyticsManagerBase from "./../../../src/common/analytics/analyticsmanagerbase";
import CmpManager from "./../../../src/common/cmp/cmpManager";
import { CmpType } from "./../../../src/common/utilities/enums";
import AnalyticsEngineER from "./../../../src/common/analytics/engines/analyticsEngineER";
import AnalyticsEngineGA from "./../../../src/common/analytics/engines/analyticsEngineGA";
import AnalyticsEngineGTM from "./engines/analyticsEngineGTM";

const kioskProductionHostname = "kiosque.dhnet.be";
const kioskUatHostname = "kiosque-uat.dhnet.be";
const kioskHostname =
  process.env.ENV === "production" ? kioskProductionHostname : kioskUatHostname;

export default class AnalyticsManager extends AnalyticsManagerBase {
  constructor(options) {
    super(options);
    this._initEngines();
    this.cmpManager = new CmpManager(CmpType.DIDOMI, options.cmp);
    this.cmpManager.on("cmp:loaded", () => {
      this._initEnginesBehindCMP();
    });
    this.cmpManager.on("userConsent:changed", () => {
      this._initEnginesBehindCMP();
      this.trigger("userConsent:changed");
    });
  }

  _initEngines() {
    this._initAnalyticsEngineGTM();
  }

  _initEnginesBehindCMP() {
    if (!this.ER && this.cmpManager.isERTrackingEnabled()) {
      this.ER = new AnalyticsEngineER(this, this._options);
    }
    if (!this.GA && this.cmpManager.getUserConsentForGA() != undefined) {
      this.GA = new AnalyticsEngineGA(this, this._options); // eslint-disable-line
    }
  }

  /**
   * Initializes the Analytics Engine GTM only in the Kiosk.
   */
  _initAnalyticsEngineGTM() {
    if (
      window.location.href.includes(kioskHostname) &&
      !window.location.href.includes("reader")
    ) {
      new AnalyticsEngineGTM(this, this._options);
    }
  }
}



// WEBPACK FOOTER //
// ./clients/tec-ldh/js/analyticsManager.js